import { useSelector } from 'react-redux';
import { Text, FlexContainer, Buttons } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { history } from 'Store';
import { emailSelector } from 'Store/modules/auth/selectors';
import { useTranslation } from 'Hooks/useTranslation';
import { GradientBg, AuthContainer } from 'Components/UI';
import Trans from 'Components/Trans';
import AppHeader from 'Components/AppHeader';
import { routes } from 'Constants/routes';
import ResendIcon from 'Assets/images/account-validation/resend.png';
import { TAXDOWN_ASSETS_DOMAIN } from 'Constants/domains';
import { AccountValidationViewProps } from './types';
import ValidationOptions from './ValidationOptions';
import * as Styled from './styles';

const View = ({ onSendCode }: AccountValidationViewProps): JSX.Element => {
  const email = useSelector(emailSelector);
  const { t } = useTranslation(locizeNS.AUTH);
  const options = [
    {
      label: 'AccountValidation.action.2',
      image: ResendIcon,
      action: onSendCode,
      testId: 'sendCodeButton',
      id: 'sendCodeButton',
    },
  ];
  return (
    <>
      <AppHeader />
      <GradientBg>
        <AuthContainer>
          <FlexContainer direction="column" align="center" justify="center">
            <Styled.Img
              src={`${TAXDOWN_ASSETS_DOMAIN}/illustrations/default/send_email_s.png`}
              alt="email-img"
            />
            <FlexContainer
              direction="column"
              gap="dimension_24"
              align="center"
              justify="center"
              fullWidth
            >
              <Text type="headline" size="S_M_S" color="dark">
                {t('AccountValidation.header')}
              </Text>
              <Styled.EmailContainer
                type="paragraphs"
                size="L_XL_S"
                color="grey"
                align="center"
                data-text="true"
              >
                {email}
              </Styled.EmailContainer>
              <Text type="paragraphs" size="L_S_S" color="grey" align="center">
                {t('AccountValidation.info')}
              </Text>
              <Styled.QuestionContainer direction="column" align="flex-start">
                <Text type="paragraphs" size="L_S_S" color="grey">
                  {t('EmailValidation.question.one')}
                </Text>
                <Text type="paragraphs" size="L_S_S" color="grey">
                  <Trans
                    ns={locizeNS.AUTH}
                    components={{
                      span: <Styled.Span />,
                    }}
                    i18nKey={t('EmailValidation.question.two')}
                  />
                </Text>
                <Text type="paragraphs" size="L_S_S" color="grey">
                  {t('EmailValidation.question.three')}
                </Text>
              </Styled.QuestionContainer>
              <ValidationOptions options={options} />
              <FlexContainer justify="center" gap="dimension_08" align="center">
                <Text type="paragraphs" size="M_S_S" color="dark">
                  {t('Auth.signUp.haveAccount')}
                </Text>
                <Buttons.Tiny
                  label={t('Auth.signUp.login')}
                  onClick={() => history.push(routes.SIGNIN)}
                  mode="default"
                />
              </FlexContainer>
            </FlexContainer>
          </FlexContainer>
        </AuthContainer>
      </GradientBg>
    </>
  );
};

export default View;
